import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../pages/Account/Service/auth.service";
import {User} from "../../../Models/User";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
isAuthenticated = false;
userData :User= null;
  constructor(private authService: AuthService, private route:Router) { }

  ngOnInit(): void {

      if (this.authService.getTokenAuth() && this.authService.getuserInfo()){
          this.isAuthenticated = true;
          this.userData= this.authService.getCurrentUserValue() as User;
          console.log(this.userData , "user")
      }

  }
    logout(){
      this.authService.logout();
      this.isAuthenticated= false;
      return this.route.navigateByUrl("/Account/login");
    }

}
